import React from 'react';
import styled from 'styled-components';
import WatermarkSvg from './watermark';

/**
 * Click through watermark to underlying elements
 * pointer-events influences the reaction to click-, tap-, scroll- und hover events.
 *
 * CSS:
 * pointer-events: none;
 * background: url('your_transparent.png');
 *
 * E11 conditional:
 * filter:progid:DXImageTransform.Microsoft.AlphaImageLoader(src='your_transparent.png', sizingMethod='scale');
 * background: none !important;
 */
// background-image: url(${(props) => props.disabled ? watermarkPreview : watermarkBeta});
// background-size: contain;
// background-repeat: no-repeat;
// background-position: 50% 50%;
const TransparentLogoDiv = styled.div.withConfig({
  displayName: "Watermark__TransparentLogoDiv",
  componentId: "sc-10dx8uy-0"
})(["display:flex;justify-content:center;align-items:center;background-origin:content-box;text-align:center;width:100%;height:100%;position:absolute;top:0;left:0;z-index:1000;opacity:", ";background-color:", ";pointer-events:", ";"], props => props.opacity || (props.smallWidget ? '.5' : '.4'), props => props.readOnly ? 'gray' : 'none', props => props.readOnly ? 'auto' : 'none');
/**
 * @component
 * Basic watermark. Can be clicked through or not if disabled.
 */

export const Watermark = ({
  readOnly,
  smallWidget,
  opacity
}) => /*#__PURE__*/React.createElement(TransparentLogoDiv, {
  opacity: opacity,
  smallWidget: smallWidget,
  readOnly: readOnly
}, /*#__PURE__*/React.createElement(WatermarkSvg, {
  smallWidget: smallWidget,
  readOnly: readOnly
}));
export default Watermark;